import React from 'react';
import { Outlet } from 'react-router-dom';

import { ReactComponent as ExpandIcon } from '../../assets/icons/expand-icon.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { closeTableModal } from '../../redux/slices/TableModalSlice';
import Header from '../header/Header';
import PageTitle from '../page-title/PageTitle';
import Sidebar from '../sidebar/Sidebar';

/**
 * GlobalTableModal
 * @returns {any} Global table modal component
 */
function GlobalTableModal() {
  const dispatch = useAppDispatch();
  const { open, title, content } = useAppSelector((state) => state.tableModal);

  /**
   * Handle close modal function
   */
  const handleClose = () => {
    dispatch(closeTableModal());
  };

  return (
    <div className="ev-layout-wrap-all">
      <div className="ev-sidebar">
        <Sidebar />
      </div>

      <div className="ev-content-wrap">
        <Header />
        <div className="ev-content">
          <Outlet />
        </div>
      </div>

      {/* ✅ GLOBAL MODAL */}
      {open && (
        <div
          className="global-modal-overlay"
          role="presentation"
          onClick={handleClose} // ⬅️ CLICK OUTSIDE CLOSE
        >
          <div
            className="global-modal-container"
            // eslint-disable-next-line unicorn/prevent-abbreviations
            onClick={(e) => e.stopPropagation()} // ⬅️ PREVENT CLOSE ON CONTENT CLICK
            role="presentation">
            <div className="global-modal-header">
              <PageTitle title={title} />
              <span
                className="modal-close-btn"
                role="presentation"
                onClick={handleClose} // ⬅️ CLOSE ICON
              >
                <ExpandIcon />
              </span>
            </div>

            <div className="global-modal-body">{content}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GlobalTableModal;
